// Referências aceitas pelo filtro de período de POST /api/contracts/search.
// Os valores precisam bater com App\Constants\ContractDateReferenceTypes do backend-core.

// Comportamento histórico do filtro: a competência gravada em `contract_date`.
export const COMPETENCE = 'competence'

// Momento em que o contrato foi reportado/criado no sistema (`createdAt`).
export const REPORT = 'report'

// Momento em que o contrato passou a valer — foi direto para Rodando ou para
// Proposta Implantada. No banco: COALESCE(deployed_at, paid_at).
export const VALIDATION = 'validation'

export const CONTRACT_DATE_REFERENCES = [
  {
    key: COMPETENCE,
    name: 'Data do contrato',
    description: 'Competência do contrato, como o filtro sempre funcionou.',
  },
  {
    key: REPORT,
    name: 'Report do contrato',
    description: 'Quando o contrato foi reportado/criado no sistema.',
  },
  {
    key: VALIDATION,
    name: 'Validação do contrato',
    description: 'Quando o contrato foi para Rodando ou Proposta Implantada.',
  },
]
